<template>
  <div class="container">
    <BaseTitle :tag="tag">{{ title }}</BaseTitle>

    <div class="shop-logo-text" :class="{ collapsed }">
      <div class="shop-logo-wrapper">
        <BaseImageExternal v-if="logo" class="shop-logo" :src="logo" />
      </div>
      <div class="shop-text text-card">
        <BaseCustomHTMLContent
          :custom-html-content="description"
          class="shop-html-content"
        />
      </div>
      <div
        class="read-more hide-medium-up mt-1"
        @click="collapsed = !collapsed"
      >
        <BaseText v-if="collapsed" class="semi-bold">
          {{ $t("shop.read-more") }}
        </BaseText>
        <BaseText v-else class="semi-bold">
          {{ $t("shop.show-less") }}
        </BaseText>
        <BaseIcon
          icon="chevron-right"
          class="chevron gray"
          :class="{ collapsed }"
        />
      </div>
      <BaseIcon
        icon="chevron-right"
        class="chevron size-52 gray hide-small"
        :class="{ collapsed }"
        @click="collapsed = !collapsed"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  logo?: string;
  title: string;
  description: string;
  tag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}>();

const collapsed = ref(true);
</script>

<style lang="scss" scoped>
$container-height: 176px;
$chevron-height: 52px;

.shop-logo-text {
  display: flex;

  justify-content: space-between;
  border-radius: $border-radius-medium;
  border: 1px solid $light-80;
  background-color: $light-95;
  padding: 0.75rem;

  @include for-small-screen {
    flex-direction: column;
  }

  &.collapsed {
    height: $container-height;

    @include for-small-screen {
      height: $container-height * 2;
    }
  }

  .shop-logo-wrapper {
    height: 150px;
    width: 250px;
    border-radius: $border-radius-medium;
    background-color: $light-100;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    margin-right: 1rem;
    @include for-small-screen {
      width: 100%;
      margin-right: 0;
    }
  }

  .shop-text {
    max-height: 100%;
    flex: 1;
    padding: 0;
    font-size: 18px;
    font-family: Inter;
    line-height: 26px;
    color: $dark-100;
    overflow: hidden;
  }

  .chevron {
    cursor: pointer;

    &:not(.collapsed) {
      transform: rotate(90deg);
    }

    &.hide-small {
      margin-top: calc($container-height / 2 - $chevron-height / 2 - 0.75rem);
    }
  }

  .read-more {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
